module.exports = __webpack_public_path__ + "d94e20c1/img/upload-icon.9179ae4e.svg";